// extracted by mini-css-extract-plugin
export default {"container":"YQAWn4Vmd1SACJJGhiQh","tooltip":"qSFFdEjjwHJ11kPA7X3U"};